import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';
import Gallery from '../components/Gallery';

const Home = () => {
  const images = useMemo(() => {
    const ctx = require.context('../img/home', false, /\.(jpg|jpeg|png)$/i);
    return ctx
      .keys()
      .sort((a, b) => {
        const num = (key) => parseInt(key.match(/EPT-(\d+)/)?.[1] ?? '0', 10);
        return num(a) - num(b);
      })
      .map((key) => ctx(key));
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={transition1}
    >
      <Gallery data={images} />
    </motion.div>
  );
};

export default Home;
